import React, { ReactElement } from "react";
import Styles from "../styles/Styles";
import MenuIcon from "@material-ui/icons/Menu";
import { DefaultLogo, FontStyles } from "../../../components";
import HomeWorkIcon from "@material-ui/icons/HomeWork";
type CustomHeaderProps = {};

function Footer({}: CustomHeaderProps) {
  return (
    <Styles.Container id="footer">
      <Styles.PeriodText>
        TESTE AUTENTICAÇÃO COMO HÓSPEDE ACOMPANHANTE
      </Styles.PeriodText>
    </Styles.Container>
  );
}

export default Footer;
